import { SearchOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { shade } from 'polished';
import styled from 'styled-components';
export const Container = styled.div`
  width: 80%;
`;
export const SearchIcon = styled(SearchOutlined)`
  margin-top: 0px !important;
`;
export const ButtonsContainer = styled.div`
  display: flex;
  margin-top: 16px;
  width: 100%;
`;
export const Edit = styled(Button)`
  background: #ffba00;
  color: #ffffff;
  &:hover {
    background-color: ${shade(0.2, '#ffba00')};
    color: #ffffff;
  }
`;
export const Cancel = styled(Button)`
  border: 0;
`;
export const ProjectMemberCard = styled.div`
  padding-top: 8px;
  padding-left: 8px;
  padding-bottom: 2px;
  border: 1px solid ${props => props.selected ? '#ffba00' : 'white'};
  border-radius: 8px;
  transition: 0.1s;
  &:hover {
    border: 1px solid ${props => props.selected ? '#ffba00' : 'lightgrey'};
  }
`;
export const MembersContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-height: 550px;
  overflow: auto;
  gap: 28px;
`;